// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__gmKV8","right":"Footer_right__Eyddw","buttons":"Footer_buttons__r9wAM"};